import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import Loader from "../componets/Loader";
import PrintReport from "../assets/SVGs/Report/PrintReport";
import { IconButton } from "@mui/material";
import ReportLogo from "../assets/SVGs/Report/ReportLogo";
import { formatCurrency } from "../componets/helper";
import { ReportAPI } from "../api/report";
import MemberNameCell from "../componets/MemberNameCell";

const ClosedBusinessReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [reportType, setReportType] = useState(null);

  const fetch = async () => {
    setIsLoading(true);
    try {
      const currentUserId = Number(localStorage.getItem("memberId"));
      const startDate = dayjs(
        localStorage.getItem("closedBusinessReport"),
      )?.format("YYYY-MM-DD");
      const endDate = dayjs()?.format("YYYY-MM-DD");

      const reportTypeFromStorage = JSON.parse(
        localStorage.getItem("closedBusinessReportType"),
      );

      setReportType(
        reportTypeFromStorage.map((status) =>
          status === "sent" ? "Referred" : status,
        ),
      );

      const reportTypeString =
        reportTypeFromStorage?.length > 1
          ? ""
          : reportTypeFromStorage[0] === "sent"
            ? "&type=Sent"
            : "&type=Received";

      const closedBusinessReport =
        await ReportAPI.getMembersCloseBusinessReport(
          startDate,
          endDate,
          `${reportTypeString}`,
          currentUserId,
        );

      setData(closedBusinessReport?.data);
    } catch (error) {
      const status = error.response?.status;
      if (status === 401) {
        navigate("/login");
      } else {
        console.error("Error fetching closed business report:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return isLoading ? (
    <Loader height="100vh" />
  ) : (
    <div className="report-section flex flex-col gap-16">
      <header className="report-header flex align-center justify-between flex-col gap-16">
        <ReportLogo width={122} height={50} />
        <div className="header-section flex align-center justify-between flex-col">
          <h1 className="header-title">Closed Businesses Report</h1>
          <p className="header-date">{`${dayjs(
            localStorage.getItem("closedBusinessReport"),
          ).format("MM/DD/YYYY")} - ${dayjs().format("MM/DD/YYYY")}`}</p>
          <p className="header-date">
            {localStorage?.getItem("closedBusinessReportTitle")}
          </p>
          <p className="header-date" style={{ textTransform: "capitalize" }}>
            {reportType.join(` and `)}
          </p>
          <p className="header-date">
            Total Realized Revenue :{" "}
            {formatCurrency(data?.total_realized_revenue)}
          </p>
          <IconButton
            sx={{
              border: "1px solid #AEBBCB",
              "@media print": {
                display: "none",
              },
            }}
            onClick={handlePrint}
            className="no-print"
          >
            <PrintReport className="no-print" />
          </IconButton>
        </div>
      </header>

      <div className="customTable closed-business-report">
        <table
          style={{
            width: "100%",
            tableLayout: "fixed",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th style={{ textAlign: "left", padding: "10px" }}>
                Closed Business Sender
              </th>
              <th style={{ textAlign: "left", padding: "10px" }}>
                Closed Business Receiver
              </th>
              <th style={{ textAlign: "left", padding: "10px" }}>
                Closed Business Date
              </th>
              <th style={{ textAlign: "left", padding: "10px" }}>
                Dollar Amount of Realized Revenue
              </th>
            </tr>
          </thead>
          <tbody>
            {data.records && data?.records?.length > 0 ? (
              data?.records.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                  }}
                >
                  <td style={{ padding: "10px" }}>
                    {row.closed_business_sender?.first_name ? (
                      <MemberNameCell member={row.closed_business_sender} />
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td style={{ padding: "10px" }}>
                    {row.closed_business_receiver?.first_name ? (
                      <MemberNameCell member={row.closed_business_receiver} />
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td style={{ padding: "10px" }}>
                    {row.closed_business_date
                      ? dayjs(row.closed_business_date).format("MM/DD/YYYY")
                      : "N/A"}
                  </td>
                  <td style={{ padding: "10px" }}>
                    {formatCurrency(row?.dollar_amount_of_realized_revenue) ||
                      0}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No Closed Businesses Available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClosedBusinessReport;
